export default __webpack_public_path__ + "static/media/house-shape-parking-rent-out.9ceb9f5b.png";